import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCRGzJfvP0Mg2Bih7vrqAq2igHkiSIpy_A",
  authDomain: "hiflow-71606.firebaseapp.com",
  projectId: "hiflow-71606",
  storageBucket: "hiflow-71606.firebasestorage.app",
  messagingSenderId: "176597515638",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const liveFirestore = firebase.firestore();

/**
 * Firestore oturumu.
 *
 * Panel Firebase'e hiç kimlik doğrulamıyordu; `live_locations` sorguları bu yüzden
 * "permission-denied" ile dönüyor ve canlı konum özelliği hiç çalışmıyordu.
 * Mobil uygulama Firebase'e giriş yaptığı için oradan yazılan konumlar okunamıyordu.
 *
 * Anonim giriş, kuralları gevşetmeden `request.auth != null` koşulunu karşılar.
 * Tek seferlik yapılır ve sonuç önbelleğe alınır; sorgu yapan her sayfa bunu bekler.
 *
 * NOT: Firebase Console → Authentication → Sign-in method altında
 * "Anonymous" sağlayıcısının etkin olması gerekir.
 */
let oturumSozu = null;

export const ensureLiveAuth = () => {
  if (oturumSozu) return oturumSozu;

  oturumSozu = new Promise((resolve) => {
    const auth = firebase.auth();

    if (auth.currentUser) {
      resolve(auth.currentUser);
      return;
    }

    const cozumle = (kullanici) => resolve(kullanici || null);

    auth.onAuthStateChanged((kullanici) => {
      if (kullanici) cozumle(kullanici);
    });

    auth.signInAnonymously().then(
      (sonuc) => cozumle(sonuc.user),
      (hata) => {
        // Giriş başarısızsa sorgular yine denensin; hata çağıran tarafta görünür.
        console.error("Firebase anonim giriş başarısız:", hata?.code || hata);
        // Sonraki sayfa geçişinde yeniden denenebilsin diye önbelleği boşaltıyoruz.
        oturumSozu = null;
        resolve(null);
      }
    );
  });

  return oturumSozu;
};
